import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Rechnungen',
  form: {
    title: 'Neue Zahlung anfordern',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Abrechnungsquelle',
    },
    billing_anchor: {
      label: 'Start der Abrechnung unter',
    },
    items: {
      label: 'Artikel',
    },
    name: {
      label: 'Name',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Betrag (NETTO)',
      tax_breakdown: '+{{tax}} MwSt. = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Name/Nummer',
    billing_mode: 'Abrechnungsquelle',
    type: 'Typ',
    status: 'Status',
    amount: 'Betrag (Brutto)',
    created_at: 'Erstellt',
    billing_anchor: 'Abrechnung von',
    invoice: 'Rechnung',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Zahlungsmethode',
    [BillingMode.InternalInvoicing]: 'Vertrieb',
  },
  types: {
    [InvoiceType.Manual]: 'Manuell',
    [InvoiceType.SetupFee]: 'Einrichtungsgebühr',
    [InvoiceType.Subscription]: 'Abonnement',
    [InvoiceType.SubscriptionBridge]: 'Abonnement (anteilig bis zum 5.)',
    [InvoiceType.SubscriptionProration]: 'Abonnement (anteiliges Upgrade)',
    [InvoiceType.DisputeFee]: 'Rückbuchungsgebühr',
    [InvoiceType.ChargebackReversalFee]: 'Gebühr für Rückbuchungsumkehr',
    [InvoiceType.SecondChargebackFee]: 'Gebühr für zweite Rückbuchung',
    [InvoiceType.RefundFailureFee]: 'Gebühr für fehlgeschlagene Erstattung',
    [InvoiceType.BillingCycle]: 'Abrechnungszeitraum',
    [InvoiceType.NegativeBalanceCompensation]: 'Ausgleich des Negativsaldos',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Anhängig',
    [InvoiceStatus.Processing]: 'Verarbeitung',
    [InvoiceStatus.Paid]: 'Bezahlt',
    [InvoiceStatus.PartiallyRefunded]: 'Teilweise erstattet',
    [InvoiceStatus.Refunded]: 'Erstattet',
    [InvoiceStatus.Failed]: 'Gescheitert',
  },
  modals: {
    invoice_creation_confirmation: {
      title:
        'Sind Sie sicher, dass Sie einen Rechnungsposten für {{amount}} NETTO an {{company}} von {{billingMode}} erstellen möchten?',
    },
    invoice_recharge_confirmation: {
      title: 'Bist du sicher?',
      description:
        '<strong>{{company}}</strong> wird <strong>{{amount}} brutto + ggf. Zahlungsausfallentschädigung</strong> von der primären Zahlungsmethode für die Rechnung {{details}} abgebucht',
      recharge_failed: {
        title: 'Stripe hat die Zahlung abgelehnt',
        convert_hint:
          'Diese Rechnung kann stattdessen über die Umsätze des Restaurants eingezogen werden. Die Stripe-Rechnung wird storniert und der offene Betrag von den nächsten Auszahlungen abgezogen.',
      },
    },
  },
  buttons: {
    show_transfers: 'Transfers anzeigen',
    hide_transfers: 'Überweisungen ausblenden',
    create: 'Erstellen',
    download_pdf: 'PDF herunterladen',
    open_payment_page: 'Zur Zahlungsseite',
    open_invoice_page: 'Offene Rechnungsdetails',
    add_item: 'Artikel hinzufügen',
    convert_to_internal_billing: 'Stattdessen über Umsätze einziehen',
    recharge_invoice: 'Rechnung aufladen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_create_invoice: 'Rechnung konnte nicht erstellt werden!',
    invoice_got_created: 'Rechnung wurde erstellt!',
    invoice_got_recharged: 'Die Rechnung wurde neu belastet. Die neue Zahlung wird bearbeitet!',
    failed_to_recharge_invoice: 'Die Rechnung wurde nicht aufgeladen!',
    invoice_got_converted_to_internal_billing:
      'Die Rechnung wird jetzt über Umsätze abgerechnet. Der offene Betrag wird von den nächsten Auszahlungen abgezogen.',
    failed_to_convert_invoice_to_internal_billing:
      'Die Rechnung konnte nicht auf Abrechnung über Umsätze umgestellt werden!',
  },
};
